import Icon from "@mui/material/Icon";
import InputAdornment from "@mui/material/InputAdornment";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { useTranslation } from "react-i18next";

interface SearchTextFieldProps {
	ariaLabel?: string;
	onChange: (value: string) => void;
	placeholder?: string;
	size?: "small" | "medium";
	sx?: TextFieldProps["sx"];
	value: string;
}

const SearchTextField = ({ ariaLabel, onChange, placeholder, size = "small", sx, value }: SearchTextFieldProps) => {
	const { t } = useTranslation("common");
	return (
		<TextField
			fullWidth
			onChange={(event) => onChange(event.target.value)}
			placeholder={placeholder ?? t("shared.searchPlaceholder")}
			size={size}
			slotProps={{
				htmlInput: { "aria-label": ariaLabel },
				input: {
					endAdornment: (
						<InputAdornment position="start">
							<Icon>search</Icon>
						</InputAdornment>
					)
				}
			}}
			sx={sx}
			value={value}
		/>
	);
};

export default SearchTextField;
